import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTestInProgress = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 7,
		cy: 7,
		r: 7,
		fill: "#9CA3AF",
		fillOpacity: .1
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 7,
		cy: 7,
		r: 3,
		fill: "#374151"
	})]
});
export default SvgTestInProgress;
